import { useTheme } from '@emotion/react';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { ButtonFilterCatalog } from '../Buttons';
import { H3 } from '../styled/typography';
import { GB_DOMAIN } from '../../lib/api/apiUrl';
import { Category } from '../../models/categories';
import { City } from '../../models';

type IPlaceFilterProps = {
  categories?: {
    results: Category[];
    count: number;
    next: null | string;
  } | null;
  query: {
    pages: number[];
    categories: Category[];
    category?: string;
  };
  onCheckCategory: (category: Category) => void;
  currentCity: City;
};

export function PlaceFilter({
  categories,
  query,
  onCheckCategory,
  currentCity,
}: IPlaceFilterProps) {
  const theme = useTheme();

  return (
    <div
      css={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        marginLeft: '-10px',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: '0 16px',
        },
      }}
    >
      <div
        css={{
          marginBottom: 16,
          paddingLeft: '-8px',
          fontSize: 12,
        }}
      >
        <H3
          css={{
            fontSize: 18,
            color: theme.colors.textSecondary,
            marginLeft: 10,
            marginBottom: 16,
          }}
        >
          Я ищу:
        </H3>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 2,
          }}
        >
          {categories?.results.map((category) => (
            <>
              <ButtonFilterCatalog
                isActive={query.categories.some(
                  (item) => item.id === category.id
                )}
                key={`categoriesFilter${category.id}`}
                callback={() => onCheckCategory(category)}
              >
                #{category.title}
              </ButtonFilterCatalog>
              <a
                css={{ display: 'none' }}
                href={`${GB_DOMAIN}/${currentCity.url}/place-catalog/${category.slug}/`}
              >
                {category.title}
              </a>
            </>
          ))}
        </div>
      </div>
    </div>
  );
}
